import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail } from "lucide-react";
import { api } from "../../lib/api";

export const AdminSubscribers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/admin/subscribers").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);
  const remove = async (id) => {
    if (!window.confirm("Eliminare questo iscritto?")) return;
    await api.delete(`/admin/subscribers/${id}`);
    toast.success("Iscritto eliminato");
    load();
  };
  if (loading) return <p className="mono text-sm">Caricamento…</p>;
  if (!items.length) return <p data-testid="admin-subscribers-empty" className="text-[rgba(246,241,232,0.7)]">Nessun iscritto alla newsletter.</p>;
  return (
    <div>
      <p className="mono text-[12px] text-[rgba(246,241,232,0.6)] mb-4">{items.length} iscritti totali</p>
      <ul data-testid="admin-subscribers-list" className="space-y-3">
        {items.map((s) => (
          <li key={s.id} data-testid={`admin-subscriber-${s.id}`} className="border border-[var(--line)] rounded-md p-4 flex flex-wrap justify-between items-center gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <span className="w-9 h-9 rounded-full grid place-items-center bg-[rgba(193,154,75,0.15)] text-[var(--amber)] shrink-0"><Mail className="w-4 h-4" /></span>
              <div className="min-w-0">
                <p className="font-semibold truncate">{s.email}</p>
                <p className="mono text-[12px] text-[rgba(246,241,232,0.7)] mt-0.5">{new Date(s.created_at).toLocaleString("it-IT")}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <a data-testid={`admin-subscriber-mail-${s.id}`} href={`mailto:${s.email}`} className="p-2 rounded-full border border-[var(--line)] hover:border-[var(--amber)]" title="Scrivi"><Mail className="w-4 h-4" /></a>
              <button data-testid={`admin-subscriber-delete-${s.id}`} onClick={() => remove(s.id)} className="p-2 rounded-full border border-[var(--line)] hover:border-red-400 hover:text-red-300" title="Elimina"><Trash2 className="w-4 h-4" /></button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};